import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/news';

function newsCreate(state, action) {
  state.data = action.payload.data;
  state.result = action.payload.result;
  state.nota = action.payload.nota;
  state.conexion = false;
  state.error = false;
}

function newsConexion(state, action) {
  state.conexion = action.payload.conexion;
}

function newsError(state, action) {
  state.error = action.payload.error;
}

const newsReducer = createSlice({
  name: 'news',
  initialState: initState,
  reducers: {
    newsCreate,
    newsConexion,
    newsError,
  },
});

export const newsActions = {
  ...newsReducer.actions,
};

export default newsReducer.reducer;
